module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustra-1-4cea723bf5ee9e0f7fa372ab13d6458d.png";